import { formatAmount, pluralize } from 'core/utilities';

export default function GrossResultsDisplay({type, pageGrossResults}) {

        if(type === 'DONATION' || type === 'CONDUIT') {
            return formatAmount(pageGrossResults.raised_amount)
        }

        return pluralize({ singular: 'lead', count: pageGrossResults.leads, showCount: true })
}